<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">


        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">选择指标名称</div>
            <el-select v-model="checkNameId" clearable placeholder="请选择指标名称" style="width:100%;margin-right: 5px;">
              <el-option
                  v-for="item in list_name"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="24" class="item">
            <div class="label">名称</div>
            <el-input v-model="edit_name" placeholder="请输入名称"></el-input>
          </el-col>

          <el-col :span="12" class="item">
            <div class="label">内容</div>
            <el-input v-model="edit_content" type="textarea" rows="5" placeholder="请输入内容"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">标准</div>
            <el-input v-model="edit_standard" type="textarea" rows="5" placeholder="请输入标准"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">分值</div>
            <el-input v-model="edit_score" placeholder="请输入分值"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_sort" placeholder="请输入排序"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: ['list_name'],
  data() {
    return {

      loading: false,

      edit_name:'',
      edit_sort:'',
      edit_content:'',
      edit_standard:'',
      edit_score:0,

      checkNameItemId:'',

      checkNameId:'',

    }
  },
  methods: {
    init(row){

      this.edit_name = row.name;
      this.edit_sort = row.sort;
      this.edit_score = row.score;
      this.edit_content = row.content;
      this.edit_standard = row.standard;

      this.checkNameId=row.checkNameId;
      this.checkNameItemId = row.id;

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.checkNameId === ''){
        this.$message("选择指标名称");
        return;
      }

      if(this.edit_name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.edit_score === ''){
        this.$message("输入分值");
        return;
      }
      if(this.edit_content === ''){
        this.$message("输入内容");
        return;
      }
      if(this.edit_standard === ''){
        this.$message("输入标准");
        return;
      }
      if(this.edit_sort === ''){
        this.$message("输入排序");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckNameItem/AdmEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),

          name: this.edit_name,
          content: this.edit_content,
          standard: this.edit_standard,
          score: this.edit_score,
          sort:this.edit_sort,

          checkNameId:this.checkNameId,
          checkNameItemId:this.checkNameItemId,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

